import { FullReview } from "@/types/meetings";
import { formatDate } from "@/utils/datetime";

import { ReviewTimelineItem } from "./ReviewTimelineItem";

interface FinalCheckProps {
  review: FullReview;
  isCoach: boolean;
}

export function FinalCheck({ review, isCoach }: FinalCheckProps) {
  if (!review || !review.product || !review.product.includesFinalCheck) {
    return null;
  }

  if (review.canceledAt) {
    return <ReviewTimelineItem intent="canceled" label="Final Check" />;
  }

  const { numRounds, numRoundsComplete } = review;
  const intent = review.completedAt
    ? "success"
    : numRounds === numRoundsComplete
      ? "active"
      : undefined;

  const waitingOnCoach = numRounds === numRoundsComplete && !review.completedAt;

  const message = review.completedAt
    ? `Sent on ${formatDate(review.completedAt, "MMM d 'at' h:mm a z")}`
    : waitingOnCoach
      ? isCoach
        ? "Send the client your final check"
        : "Your coach will send you their final check as soon as they are finished"
      : undefined;

  return (
    <ReviewTimelineItem intent={intent} label="Final Check" message={message} />
  );
}
